import React from 'react';
import '../../common/SubNavbar.css'
import '../../common/CommonText.css'

const TotalCount = ({ TotalName, TotalCount }) => {
  // Format TotalCount to add a leading zero if it's less than 10
  const formattedCount = TotalCount < 10 ? `0${TotalCount}` : TotalCount;

  return (
    <>
      <span className='muted-text normal-text fts-15 black'>
        {TotalName}: <span className='page-name normal-text fts-15 blue '><b>{formattedCount}</b></span>
      </span>
      {/* <span className='page-name normal-text fts-15 blue '></span> */}
    </>
  );
};

export default TotalCount;
